const organization_details = {
    departments: {
        leader: 'Leitung',
        leaders: 'Abteilungsleitung',
        led_departments: 'Geleitete Abteilungen',
        edit_leaders: 'Leitung verwalten',
        add_leader: 'Hinzufügen',
        remove_leader: 'Entfernen',
        no_leaders: 'Keine Leitung festgelegt',
        local: 'Lokal verwaltet',
        managed_members: 'Mitglieder im Verwaltungsbereich',
        leader_scope_hint: 'Mitgliedschaften in geleiteten Abteilungen und Unterabteilungen verwalten.',
        leader_permission_hint: 'Die Leitung verwaltet Mitgliedschaften ihrer Abteilungen und Unterabteilungen, jedoch keine Organisationsrollen oder Hierarchien.',
        primary_synced: 'Die Hauptabteilung wird von Feishu verwaltet.',
        status_active: 'Aktiv',
        status_suspended: 'Gesperrt',
        status_departed: 'Ausgeschieden',
        status_pending: 'Aktivierung ausstehend',
        search: 'Suchen',
        previous_page: 'Vorherige Seite',
        next_page: 'Nächste Seite',
        directory_title: 'Organisationsmitglieder',
        member_name: 'Mitglied',
        search_members: 'Nach Name oder Benutzername suchen',
        include_descendants: 'Unterabteilungen einbeziehen',
        no_members: 'Keine passenden Mitglieder.',
        all_members: 'Alle Mitglieder',
        all_departments: 'Alle Abteilungen',
        edit_member: 'Abteilungen bearbeiten',
        add_child: 'Unterabteilung hinzufügen',
        expand_department: '{{name}} aufklappen',
        collapse_department: '{{name}} zuklappen',
        title: 'Abteilungen',
        description: 'Abteilungen und Mitgliederzuordnungen dieser Organisation verwalten.',
        create: 'Abteilung erstellen',
        edit: 'Abteilung bearbeiten',
        name: 'Abteilungsname',
        parent: 'Übergeordnete Abteilung',
        root: 'Keine übergeordnete Abteilung',
        id: 'Abteilungs-ID',
        members: 'Abteilungen der Mitglieder',
        member_id: 'Benutzer-ID des Mitglieds',
        primary: 'Hauptabteilung',
        none: 'Nicht festgelegt',
        assignments: 'Abteilungszuordnungen',
        no_assignments: 'Noch keine Abteilungszuordnungen.',
        assignment_hint: 'Lokale Abteilungen und optional eine Hauptabteilung zuweisen. Verzeichniszuordnungen sind schreibgeschützt.',
        empty: 'Noch keine Abteilungen.',
        readonly: 'Sie können Abteilungen und eigene Zuordnungen ansehen. Änderungen nimmt die Organisationsverwaltung vor.',
        load_error: 'Daten konnten nicht geladen werden. Bitte erneut versuchen.',
        mutation_error: 'Speichern fehlgeschlagen. Prüfen Sie Berechtigungen, Mitgliedschaft und Abteilungshierarchie.',
        loading: 'Wird geladen…',
        synced: 'Vom Verzeichnis verwaltet',
        choose: 'Abteilungen suchen',
        organizations_title: 'Organisationen und Abteilungen',
        organizations_description: 'Organisation auswählen, um ihre Abteilungen anzuzeigen oder zu verwalten.',
        no_organizations: 'Sie gehören keiner Organisation an. Kontaktieren Sie die Organisationsverwaltung.',
        organization: 'Aktuelle Organisation',
        choose_organization: 'Organisation auswählen',
        delete_title: 'Abteilung löschen',
        delete_description: '„{{name}}“ löschen? Verschieben Sie zuerst Mitglieder und Unterabteilungen.',
    },
    directory: {
        leaders_label: 'Abteilungsleitung',
        local_department_leader: 'Lokal zugewiesene Abteilungsleitung',
        status_active: 'Aktiv',
        status_suspended: 'Gesperrt',
        status_departed: 'Ausgeschieden',
        status_pending: 'Aktivierung ausstehend',
        profiles_label: 'Quelldaten',
        primary_label: 'Hauptabteilungsänderungen',
        deactivated_label: 'Deaktivierte Identitäten',
        reactivated_label: 'Reaktivierte Identitäten',
        lifecycle_notice: 'Beibehaltene Rollenzuweisungen: {{count}}. Bei der Reaktivierung werden die bisherigen Berechtigungen wiederhergestellt.',
        title: 'Feishu-Verzeichnis',
        description: 'Abteilungen und Mitglieder über einen Feishu-Connector in diese Organisation importieren.',
        identity_notice: 'Verwenden Sie einen Connector mit Verzeichnisbereitstellung. Das Ändern einer bestehenden Connector-Identität erfordert eine Kontomigration.',
        connector: 'Feishu-Connector-ID',
        preview: 'Synchronisierung prüfen',
        preview_title: 'Synchronisierungsvorschau',
        preview_description: 'Prüfen Sie das Verzeichnis vor dem Import. Bei Änderungen ist eine neue Vorschau nötig.',
        import: 'Synchronisierung bestätigen',
        success: '{{departments}} Abteilungen und {{users}} Mitglieder importiert; {{createdUsers}} Konten erstellt. Entfernt: {{removedDepartments}} Abteilungen, {{removedMemberships}} Mitgliedschaften und {{removedAssignments}} Zuordnungen.',
        failure: 'Verzeichnis konnte nicht gelesen oder importiert werden. Prüfen Sie Berechtigungen und Sichtbarkeit, dann erneut Vorschau öffnen.',
        behavior_title: 'Importverhalten',
        mode: 'Namen, Avatare, Abteilungen und Hauptabteilungen synchronisieren. Fehlende oder inaktive Mitglieder verlieren nur den Zugriff auf diese Organisation; Rollen, lokale Zuweisungen, globale Konten und andere Organisationsidentitäten bleiben erhalten. E-Mail und Telefon sind Quelldaten, keine Anmeldedaten.',
        limits: 'Pro Import: 1000 Abteilungen, 5000 Benutzer, 10000 Zuordnungen; 60 Sekunden Lesezeit. Unvollständige oder zu große Importe werden abgelehnt.',
        counts: '{{departments}} Abteilungen · {{users}} Mitglieder',
        departments_label: 'Abteilungen',
        members_label: 'Organisationsmitgliedschaften',
        assignments_label: 'Abteilungszuordnungen',
        item: 'Element',
        added: 'Hinzufügen',
        updated: 'Aktualisieren',
        removed: 'Entfernen',
        cleanup_notice: 'Namen, Avatare, Abteilungen und Hauptabteilungen synchronisieren. Fehlende oder inaktive Mitglieder verlieren nur den Zugriff auf diese Organisation; Rollen, lokale Zuweisungen, globale Konten und andere Organisationsidentitäten bleiben erhalten. E-Mail und Telefon sind Quelldaten, keine Anmeldedaten.',
        conflicts_title: '{{count}} Konflikte verhindern die Synchronisierung. Lokale Abhängigkeiten auflösen und erneut eine Vorschau erstellen.',
        removals_title: 'Beispiele entfernter Elemente (maximal 20 je Kategorie)',
        local_child_department: 'Lokale Unterabteilung',
        unowned_assignment: 'Lokale oder ältere Zuordnung ohne Herkunftsnachweis',
        local_member_roles: 'Mitglied hat lokal zugewiesene Rollen',
        unlinked_identity: 'Verzeichnisidentität wurde getrennt',
    },
    page_title: 'Organisationsdetails',
    delete_confirmation: 'Wenn gelöscht, verlieren alle Mitglieder ihre Mitgliedschaft und Rollen in dieser Organisation. Diese Aktion kann nicht rückgängig gemacht werden.',
    organization_id: 'Organisations-ID',
    settings_description: 'Organisationen repräsentieren die Teams, Geschäftskunden und Partnerunternehmen, die auf Ihre Anwendungen zugreifen können.',
    name_placeholder: 'Der Name der Organisation, muss nicht eindeutig sein.',
    description_placeholder: 'Eine Beschreibung der Organisation.',
    member: 'Mitglied',
    member_other: 'Mitglieder',
    add_members_to_organization: 'Mitglieder zur Organisation {{name}} hinzufügen',
    add_members_to_organization_description: 'Suchen Sie nach geeigneten Benutzern, indem Sie nach Name, E-Mail, Telefon oder Benutzer-ID suchen. In den Suchergebnissen werden keine bereits vorhandenen Mitglieder angezeigt.',
    add_with_organization_role: 'Mit Organisation Rollen hinzufügen',
    user: 'Benutzer',
    application: 'Anwendung',
    application_other: 'Anwendungen',
    add_applications_to_organization: 'Anwendungen zur Organisation {{name}} hinzufügen',
    add_applications_to_organization_description: 'Suchen Sie nach passenden Anwendungen, indem Sie nach App-ID, Name oder Beschreibung suchen. Bereits vorhandene Anwendungen werden in den Suchergebnissen nicht angezeigt.',
    at_least_one_application: 'Mindestens eine Anwendung ist erforderlich.',
    remove_application_from_organization: 'Anwendung aus der Organisation entfernen',
    remove_application_from_organization_description: 'Nach dem Entfernen verliert die Anwendung ihre Zuordnung und Rollen in dieser Organisation. Diese Aktion kann nicht rückgängig gemacht werden.',
    search_application_placeholder: 'Suche nach App-ID, Name oder Beschreibung',
    roles: 'Organisationsrollen',
    authorize_to_roles: 'Berechtige {{name}} auf die folgenden Rollen zuzugreifen:',
    edit_organization_roles: 'Organisationsrollen bearbeiten',
    edit_organization_roles_title: 'Organisationsrollen von {{name}} bearbeiten',
    remove_user_from_organization: 'Benutzer von der Organisation entfernen',
    remove_user_from_organization_description: 'Wenn entfernt, verliert der Benutzer seine Mitgliedschaft und Rollen in dieser Organisation. Diese Aktion kann nicht rückgängig gemacht werden.',
    search_user_placeholder: 'Nach Name, E-Mail, Telefon oder Benutzer-ID suchen',
    at_least_one_user: 'Mindestens ein Benutzer ist erforderlich.',
    organization_roles_tooltip: 'Die Rollen, die dem {{type}} innerhalb dieser Organisation zugewiesen sind.',
    custom_data: 'Benutzerdefinierte Daten',
    custom_data_tip: 'Benutzerdefinierte Daten sind ein JSON-Objekt, das verwendet werden kann, um zusätzliche Daten zu speichern, die mit der Organisation verbunden sind.',
    invalid_json_object: 'Ungültiges JSON-Objekt.',
    branding: {
        name: 'Branding',
        description: 'Passen Sie Ihr organisationsweites Anmeldeerlebnis an.',
        organization_level_sie: 'Organisationsweites Anmeldeerlebnis',
        organization_level_sie_switch: 'Aktivieren Sie das organisationsweite Anmeldeerlebnis und richten Sie organisationsspezifisches Branding ein. Wenn deaktiviert, fällt es zuerst auf das App-Anmeldeerlebnis und dann auf das Omni-Anmeldeerlebnis zurück.',
        logo: 'Organisationslogos',
        logo_tooltip: 'Sie können die Organisations-ID übergeben, um dieses Logo im Anmeldeerlebnis anzuzeigen; die dunkle Version des Logos wird benötigt, wenn der Dunkelmodus in den Omni-Anmeldeerlebniseinstellungen aktiviert ist. <a>Mehr erfahren</a>',
    },
    jit: {
        title: 'Just-in-Time-Bereitstellung',
        description: 'Benutzer können der Organisation automatisch beitreten und bei ihrer ersten Anmeldung über einige Authentifizierungsmethoden Rollen zugewiesen bekommen. Sie können Anforderungen festlegen, die für die Just-in-Time-Bereitstellung erfüllt werden müssen.',
        email_domain: 'E-Mail-Domain-Bereitstellung',
        email_domain_description: 'Neue Benutzer, die sich mit ihren verifizierten E-Mail-Adressen oder über die soziale Anmeldung mit verifizierten E-Mail-Adressen anmelden, treten automatisch der Organisation bei. <a>Mehr erfahren</a>',
        email_domain_placeholder: 'E-Mail-Domains für die Just-in-Time-Bereitstellung eingeben',
        invalid_domain: 'Ungültige Domain',
        domain_already_added: 'Domain bereits hinzugefügt',
        sso_enabled_domain_warning: 'Sie haben eine oder mehrere E-Mail-Domains eingegeben, die mit dem Enterprise SSO verknüpft sind. Benutzer mit diesen E-Mails folgen dem Standard-SSO-Fluss und werden dieser Organisation nicht bereitgestellt, es sei denn, das Enterprise SSO ist konfiguriert.',
        enterprise_sso: 'Enterprise SSO Bereitstellung',
        no_enterprise_connector_set: 'Sie haben noch keinen Enterprise SSO-Connector eingerichtet. Fügen Sie zuerst Connectors hinzu, um die Enterprise SSO-Bereitstellung zu aktivieren. <a>Einrichten</a>',
        add_enterprise_connector: 'Enterprise-Connector hinzufügen',
        enterprise_sso_description: 'Neue Benutzer oder bestehende Benutzer, die sich zum ersten Mal über Enterprise SSO anmelden, treten automatisch der Organisation bei. <a>Mehr erfahren</a>',
        organization_roles: 'Standard-Organisationsrollen',
        organization_roles_description: 'Weisen Sie Benutzerrollen zu, wenn sie der Organisation durch die Just-in-Time-Bereitstellung beitreten.',
    },
    mfa: {
        title: 'Multi-Faktor-Authentifizierung (MFA)',
        tip: 'Wenn MFA erforderlich ist, werden Benutzer ohne MFA-Konfiguration abgelehnt, wenn sie versuchen, ein Organisationstoken auszutauschen. Diese Einstellung wirkt sich nicht auf die Benutzerauthentifizierung aus.',
        description: 'Erfordern Sie, dass Benutzer die Multi-Faktor-Authentifizierung konfigurieren, um auf diese Organisation zuzugreifen.',
        no_mfa_warning: 'Für Ihren Mandanten sind keine Multi-Faktor-Authentifizierungsmethoden aktiviert. Benutzer können nicht auf diese Organisation zugreifen, bis mindestens eine <a>Multi-Faktor-Authentifizierungsmethode</a> aktiviert ist.',
    },
};
export default Object.freeze(organization_details);
